import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import colors from '../../styles/colors'
import arrow from '../../assets/whiteArrow.png'

const StyledButtonGoBack = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    height: 50px;
    width: 50px;
    background-color: ${colors.first};
    color: white;
    border-radius: 0 0 20px 0;
    box-shadow: 0 0 10px grey;
    img {
        width: 25px;
        rotate: 90deg;
        position: absolute;
        top: 15px;
        right: 12px;
        transition: all 0.3s ease;
        &:hover {
            right: 15px;
        }
    }
    &:hover {
        cursor: pointer;
    }
`

export default function GoBackButton() {
    const navigate = useNavigate() // Initialiser le hook useNavigate

    const handleBack = () => {
        navigate(-1) // Revenir à la page précédente
    }

    return (
        <StyledButtonGoBack onClick={handleBack}>
            <img src={arrow} alt="go back" />
        </StyledButtonGoBack>
    )
}
